import { useEffect } from 'react'

import { useServerTimeOffsetMs } from '~/hooks/useServerTimeOffsetMs'
import { now as serverNow } from '~/models/clock'

/** 境界を越えてから読むためのマージン。 */
const MARGIN_MS = 1000

/**
 * OCCTO の受付時間外 (AC-PLC-062) で止めている提出が、 `heldUntil` (前日 17:00) を
 * 過ぎたら詳細を 1 回だけ読み直す hook。
 *
 * 押せるかは開いた時点の backend の判定 (`directSubmitHeldUntil`) で決め、 ブラウザで
 * 時刻を比べて活性に戻さない。 未提出・送信失敗の版は詳細をポーリングしないため、
 * 開いたまま 17:00 を迎えた時に読み直して backend の判定を取り直す。
 */
export function useRefetchWhenSubmitHoldEnds(
  heldUntil: Date | undefined,
  refetch: () => unknown,
): void {
  const heldUntilMs = heldUntil?.getTime()
  // server time offset は session RPC 完了時に確定しうるので、 確定時に予約し直す。
  const offsetMs = useServerTimeOffsetMs()
  useEffect(() => {
    if (heldUntilMs === undefined) return
    const delayMs = Math.max(heldUntilMs - serverNow().getTime() + MARGIN_MS, 0)
    const timerId = setTimeout(() => {
      void refetch()
    }, delayMs)
    return () => {
      clearTimeout(timerId)
    }
  }, [heldUntilMs, refetch, offsetMs])
}
